class ProductVideo extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.stickyBar = document.querySelector('.sticky-add-to-cart__bar');
    this.resizeObserver = new ResizeObserver(this.updateMaxHeight);
    this.resizeObserver.observe(document.body);
    if (this.stickyBar) {
      this.resizeObserver.observe(this.stickyBar);
      this.stickyBarObserver = new MutationObserver(this.updateMaxHeight);
      this.stickyBarObserver.observe(this.stickyBar, { attributes: true, attributeFilter: ['data-stuck'] });
    }
    window.addEventListener('resize', this.updateMaxHeight, { signal: this.abortController.signal });
    this.addEventListener('error', this.handleMediaError, {
      capture: true,
      signal: this.abortController.signal,
    });
    this.updateMaxHeight();
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.resizeObserver?.disconnect();
    this.stickyBarObserver?.disconnect();
  }

  updateMaxHeight = () => {
    const headerHeight = Number.parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    const stickyHeight = this.stickyBar?.dataset.stuck === 'true' ? this.stickyBar.getBoundingClientRect().height : 0;
    const availableHeight = Math.max(0, window.innerHeight - headerHeight - stickyHeight);

    this.style.setProperty('--product-video-max-height', `${availableHeight}px`);
  };

  handleMediaError = (event) => {
    if (!(event.target instanceof HTMLVideoElement) && !(event.target instanceof HTMLSourceElement)) return;

    const media = this.querySelector('[data-product-video-media]');
    const fallback = this.querySelector('[data-product-video-error]');

    media?.setAttribute('hidden', '');
    fallback?.removeAttribute('hidden');
  };
}

if (!customElements.get('product-video')) {
  customElements.define('product-video', ProductVideo);
}
